import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import React from 'react';

import Panel from 'react-bootstrap/lib/Panel';

import {
  faRocket,
  faRuler,
  faList,
  faChartLine,
  faDollarSign,
} from '@fortawesome/free-solid-svg-icons';

import Link from '../../../../../components/Link';
import PageLayout from '../../../../../components/PageLayout';

import ShadowerLink from '../../../../../components/ShadowerLink';

import Navbar from '../../../../../components/Handbook/Navbar';

import s from '../../HandbookPage.scss';

class ExpectationsPage extends React.Component {
  render() {
    return (
      <PageLayout className={s.page}>
        <div className={s.container}>
          <div className={s.navbar}>
            <div className={s.title}>Shadowing Handbook</div>
            <Navbar
              navbarIcon={faRocket}
              navbarSection="Getting Started"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/welcome-to-shadower"
                  >
                    Welcome to Shadower
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/how-shadower-works"
                  >
                    How Shadower Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/working-with-businesses"
                  >
                    Working with Businesses
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/shadowing-guidelines"
                  >
                    Shadowing Guidelines
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faRuler}
              navbarSection="Planning a Session"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/choosing-a-topic"
                  >
                    Choosing a Topic
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/interactivity-level"
                  >
                    Interactivity Level
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/session-type"
                  >
                    Session Type
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/providing-resources"
                  >
                    Providing Resources
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faList}
              navbarSection="Managing a Session"
              navbarSubsection={
                <div>
                  <Link
                    className={cx(s.link, s.active)}
                    to="/handbook/managing-a-session/expectations"
                  >
                    Expectations
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/managing-a-session/session-flow"
                  >
                    Session Flow
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/managing-a-session/maximizing-your-time"
                  >
                    Maximizing Your Time
                  </Link>
                </div>
              }
              overrideDefault
            />

            <Navbar
              navbarIcon={faChartLine}
              navbarSection="Promoting Your Profile"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/how-the-platform-works"
                  >
                    How the Platform Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/optimizing-your-profile"
                  >
                    Optimizing Your Profile
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/marketing-yourself"
                  >
                    Marketing Yourself
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/how-to-build-a-following"
                  >
                    How to Build a Following
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faDollarSign}
              navbarSection="Earning Revenue"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/earning-revenue/how-payment-works"
                  >
                    How Payment Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/earning-revenue/connecting-with-the-community"
                  >
                    Connecting with the Community
                  </Link>
                </div>
              }
            />

            <Link className={s.newProfileLink} to="/user/profiles/new">
              Create a shadowing profile
            </Link>
          </div>

          <div className={s.explanation}>
            <Panel>
              <Panel.Heading>
                <div>Managing a Session</div>
              </Panel.Heading>
              <Panel.Body>
                <div className={s.handbookTitle}>A guide for experts</div>
                <div className={s.subsectionTitle}>Expectations</div>

                <p>
                  Successfully facilitating a shadowing session requires you to
                  meet certain expectations.
                </p>

                <div className={s.contentContainer}>
                  <div>
                    <strong>Conduct</strong>
                  </div>

                  <p>
                    On Shadower, we expect all of our experts to maintain a
                    high-level of professionalism at all times and foster a
                    supportive, education-focused environment. With that in
                    mind, we kindly request that you:
                  </p>

                  <ul>
                    <li>
                      Refrain from swearing or using any form of vulgarity
                    </li>

                    <li>
                      Foster a safe and comfortable learning environment for
                      people of all backgrounds
                    </li>

                    <li>
                      Do not use your smartphone unless it is work-related
                    </li>

                    <li>Maintain a clean, organized working environment</li>
                  </ul>
                </div>

                <div className={s.contentContainer}>
                  <div>
                    <strong>Observation-Only Sessions</strong>
                  </div>

                  <p>During observation-only session, you are expected to:</p>

                  <ul>
                    <li>
                      Still devote an appropriate amount of time to your
                      shadower
                    </li>

                    <li>Answer questions when they arise</li>

                    <li>Reasonably provide as much explanation as possible</li>
                  </ul>
                </div>

                <div className={s.contentContainer}>
                  <div>
                    <strong>Interactive Sessions</strong>
                  </div>

                  <p>During interactive session, you are expected to:</p>

                  <ul>
                    <li>Provide hands-on training</li>

                    <li>
                      Let your shadower operate or use your tools or equipment
                      in some form
                    </li>

                    <li>
                      Work alongside you to create, alter or enhance a
                      work-related or personal project
                    </li>
                  </ul>
                </div>

                <div className={s.contentContainer}>
                  <p>
                    While not required, some shadowers may expect you to provide
                    some sort of additional educational resources, which can be
                    found in the{' '}
                    <Link to="/handbook/planning-a-session/providing-resources">
                      Providing Resources
                    </Link>{' '}
                    section.
                  </p>
                </div>

                <ShadowerLink
                  className={s.nextLink}
                  to="/handbook/managing-a-session/session-flow"
                >
                  Next {'>'}
                </ShadowerLink>
              </Panel.Body>
            </Panel>
          </div>
        </div>
      </PageLayout>
    );
  }
}

export default withStyles(s)(ExpectationsPage);
